module.exports = __webpack_public_path__ + "assets/976dcee1eda0e149eda39dd7e8d98ed6.mp3";